<template>
  <div
    :class="['card-app', selected ? 'selected' : '']"
    @click="() => selectAppClicked(id)"
  >
    <div class="card-app-img-box">
      <img :src="srcImage" :alt="title" />
    </div>
    <div class="card-app-content">
      <h3>{{ title }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardApp",
  props: {
    selected: Boolean,
    onClick: Function,
    id: [Number, String],
    title: String,
    srcImage: String
  },
  methods: {
    selectAppClicked(id) {
      this.$emit("click", id);
    }
  }
};
</script>

<style lang="scss">
.card-app {
  width: 150px;
  height: 150px;
  position: relative;
  background: #fff;
  display: flex;
  margin: 30px 10px;
  border-radius: 10px;
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  user-select: none;

  &-img-box {
    position: absolute;
    top: 9px;
    left: 9px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    transition: 0.5s ease-in-out;

    img {
      max-width: 100px;
      transition: 0.5s ease-in-out;
    }
  }

  &:hover,
  &.selected {
    .card-app-img-box {
      width: 100px;
      height: 100px;
      left: calc(50% - 50px);
      top: -20px;

      img {
        max-width: 75px;
      }
    }
  }
  &.selected {
    .card-app-img-box {
      box-shadow: inset 0px 1px 20px rgb(70, 70, 70);
    }
  }
  &-content {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 20px;

    h3 {
      font-size: 16px;
    }
  }
  &.selected {
    color: #007bff;
  }
}
</style>
